import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import PaySlipSpread from "./components/PaySlipSpread";
import PaySlipTable from "./components/PaySlipTable";
import { getMonths } from "../../settings/SettingService";
import PaySlipLogTable from "./components/log/PaySlipLogTable";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PaySlipBody() {
  const [tab, setTab] = useState(0);
  const handleChange = (event, value) => {
    setTab(value);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Diffusion bulletins de paie" {...a11yProps(0)} />
          <Tab label="Gérer les bulletins de paie" {...a11yProps(1)} />
          <Tab label="Journal de diffusion" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={tab} index={0}>
        <PaySlipSpread />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <PaySlipTable />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={2}>
        <PaySlipLogTable />
      </CustomTabPanel>
    </Box>
  );
}
